<template>
  <div>
    <v-form ref="form">
      <div>
        <v-checkbox label="Cliente já cadastrado" v-model="client_already_exists"></v-checkbox>
        <SelectOneClient v-if="client_already_exists" @changeClient="handleSelectedClient"></SelectOneClient>
      </div>
      
    </v-form>
  </div>
</template>

<script>
import Api from '@/api/index'
import validations from "@/mixins/validations";

export default {
  name: 'ModalityOwnClientForm',
  mixins: [ validations ],
  components:{
    SelectOneClient: () => import("@/_backoffice/_financial/components/shared/SelectOneClient.vue"),
  },
  props: {
    model: {
      type: Object,
    },
  },
  data() {
    return {
      client_already_exists: false,
    }
  },
  methods: {
    handleSelectedClient(client_id){
      this.model.own_client_attributes = {}
      this.model.own_client_attributes.id = client_id
    },
    resetClient(){
      this.model.own_client_attributes = null
    },
    validate(){
      return this.$refs.form.validate()
    },
  },
  watch:{
    client_already_exists(nv){
      if(!nv){
        this.resetClient()
      }
    }
  }
}
</script>
